import { gql } from '@apollo/client';

export const GET_PROFILE_INFO = gql`
  query {
    user {
      dashboard {
        me {
          id
          firstName
          lastName
          description
          email
          photoUrl
          gender
          phone
          notificationTypes
          birthDate
          preferredLanguages
          selectedLanguage
          address {
            country
            city
            address
            zipcode
          }
          professionalNumber
          specialities
          acts
          education {
            text
            startYear
            endYear
          }
          experience {
            text
            startYear
            endYear
          }
          subOrganizations {
            id
            name
          }
          careTeams {
            id
            name
          }
          roleIds
          roles
          newRoles {
            id
            name
            type
            permissions {
              id
              name
              permissions {
                id
                name
                permissions {
                  create
                  read
                  update
                  delete
                  retire
                  activate
                  publish
                }
              }
            }
          }
          permissions {
            id
            name
            permissions {
              create
              read
              update
              delete
              retire
              activate
              publish
            }
          }
          sendbirdId
          matrixUserId
          workingHours {
            dayOfWeek
            morningOpeningTime
            morningClosingTime
            afternoonOpeningTime
            afternoonClosingTime
          }
          appointmentDuration
        }
      }
    }
  }
`;

export interface Practitioner {
  id: string;
  firstName: string;
  lastName: string;
  description: string;
  email: string;
  photoUrl: string;
  gender: string;
  phone: string;
  notificationTypes: string[];
  birthDate: string;
  preferredLanguages: string[];
  selectedLanguage: string;
  address: {
    country: string;
    city: string;
    address: string;
    zipcode: string;
  };
  professionalNumber: string;
  specialities: string[];
  acts: string[];
  education: {
    text: string;
    startYear: string;
    endYear: string;
  };
  experience: {
    text: string;
    startYear: string;
    endYear: string;
  };
  subOrganizations: {
    id: string;
    name: string;
  }[];
  careTeams: {
    id: string;
    name: string;
  }[];
  roleIds: string[];
  roles: string[];
  newRoles: {
    id: string;
    name: string;
  }[];
  permissions: {
    id: string;
    name: string;
    permissions: {
      create: boolean;
      read: boolean;
      update: boolean;
      delete: boolean;
      retire: boolean;
      activate: boolean;
      publish: boolean;
    };
  }[];
  sendbirdId: string;
  matrixUserId: string;
  workingHours: {
    dayOfWeek: string;
    morningOpeningTime: string;
    morningClosingTime: string;
    afternoonOpeningTime: string;
    afternoonClosingTime: string;
  }[];
  appointmentDuration: number;
}

export interface GetProfileInfoResponse {
  user: {
    dashboard: {
      me: Practitioner;
    };
  };
}
